import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as EntertainmentEventVenuesReducer from './entertainment-event-venues.reducers';
import * as EntertainmentEventPerformancesReducer from './entertainment-event-performances.reducers';
import * as EntertainmentEventReducer from './entertainment-event.reducers';
import * as EntertainmentEventBookingReducer from './entertainment-event-booking.reducers';
import * as EntertainmentEventTicketTypeReducer from './entertainment-event-ticket-type-reducers';

export interface EntertainmentEventState {
  entertainmentEvent: EntertainmentEventReducer.EntertainmentEventState;
  entertainmentEventVenues: EntertainmentEventVenuesReducer.EntertainmentEventVenuesState;
  entertainmentEventPerformances: EntertainmentEventPerformancesReducer.EntertainmentEventPerformancesState;
  entertainmentEventBooking: EntertainmentEventBookingReducer.EntertainmentEventBookingState;
  entertainmentEventTicketType: EntertainmentEventTicketTypeReducer.EntertainmentEventTicketType;
}

export const reducers: ActionReducerMap<EntertainmentEventState> = {
  entertainmentEvent: EntertainmentEventReducer.reducer,
  entertainmentEventVenues: EntertainmentEventVenuesReducer.reducer,
  entertainmentEventPerformances: EntertainmentEventPerformancesReducer.reducer,
  entertainmentEventBooking: EntertainmentEventBookingReducer.reducer,
  entertainmentEventTicketType: EntertainmentEventTicketTypeReducer.reducer,
};

export const getEntertainmentEventState = createFeatureSelector<EntertainmentEventState>('entertainment-event');
